import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "min-h-[calc(100vh-140px)]" }
const _hoisted_2 = { class: "overflow-hidden rounded-lg border border-slate-200 bg-white shadow-[0_12px_30px_rgba(15,23,42,0.06)]" }
const _hoisted_3 = { class: "grid min-h-[520px] grid-cols-1 lg:grid-cols-[minmax(0,1fr)_380px]" }
const _hoisted_4 = { class: "flex flex-col justify-between p-8 lg:p-10" }
const _hoisted_5 = { class: "mt-10 flex flex-wrap items-center gap-3" }
const _hoisted_6 = { class: "border-t border-slate-200 bg-slate-50 p-6 lg:border-l lg:border-t-0" }
const _hoisted_7 = { class: "rounded-lg border border-slate-200 bg-white p-5" }
const _hoisted_8 = { class: "flex items-center gap-3" }
const _hoisted_9 = { class: "min-w-0" }
const _hoisted_10 = { class: "mt-0.5 truncate text-sm font-medium text-slate-500" }
const _hoisted_11 = { class: "mt-4 rounded-lg border border-slate-200 bg-white p-5" }
const _hoisted_12 = { class: "mt-4 flex flex-col gap-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createStaticVNode("<div><div class=\"inline-flex items-center gap-2 rounded-full border border-rose-100 bg-rose-50 px-3 py-1.5 text-sm font-bold text-rose-700\"><i class=\"pi pi-exclamation-circle text-sm\"></i><span>Route không tồn tại</span></div><div class=\"mt-10 max-w-3xl\"><div class=\"text-[84px] font-black leading-none text-slate-900\"> 404 </div><h1 class=\"mt-4 text-4xl font-black leading-tight text-slate-900\"> Không tìm thấy trang bạn yêu cầu </h1><p class=\"mt-4 max-w-2xl text-[16px] font-medium leading-7 text-slate-500\"> Đường dẫn có thể đã bị đổi, bị xóa, hoặc bạn đang truy cập nhầm địa chỉ. Hãy quay về màn hình gửi tin nhắn để tiếp tục thao tác. </p></div></div>", 1)),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Button, {
              label: "Về trang gửi tin nhắn",
              icon: "pi pi-send",
              iconPos: "left",
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.goTo('/sendmessage')))
            }),
            _createVNode(_component_Button, {
              label: "Quay lại",
              icon: "pi pi-arrow-left",
              iconPos: "left",
              outlined: "",
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.goBack()))
            })
          ])
        ]),
        _createElementVNode("aside", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _cache[4] || (_cache[4] = _createElementVNode("div", { class: "flex h-10 w-10 items-center justify-center rounded-lg bg-teal-50 text-teal-700" }, [
                _createElementVNode("i", { class: "pi pi-link text-sm" })
              ], -1)),
              _createElementVNode("div", _hoisted_9, [
                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "text-sm font-black text-slate-900" }, " Đường dẫn hiện tại ", -1)),
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$route.fullPath), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-sm font-black text-slate-900" }, " Màn hình thường dùng ", -1)),
            _createElementVNode("div", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.quickLinks, (item) => {
                return (_openBlock(), _createBlock(_component_Button, {
                  key: item.to,
                  label: item.label,
                  icon: `pi ${item.icon}`,
                  iconPos: "left",
                  outlined: "",
                  class: "!justify-start !border-slate-200 !bg-white !text-slate-700 hover:!bg-teal-50 hover:!text-teal-800",
                  onClick: ($event: any) => ($setup.goTo(item.to))
                }, null, 8, ["label", "icon", "onClick"]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}